<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-wallet"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.editarConta }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Grid de Cards -->
<div class="cards-container">
  <!-- Coluna Esquerda -->
  <div class="column-left">
    <!-- Card Dados da Conta -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-id-card"></i>
        </div>
        <span class="card-header-title">{{ texts.dadosDaConta }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ labels.tituloDaConta }} <span class="required">*</span></label>
            <input [class.error-field]="isFormSubmitted && !form.tituloDaConta"
                   [(ngModel)]="form.tituloDaConta" type="text" pInputText
                   [placeholder]="placeholders.tituloDaConta" class="w-full" />
          </div>
          <div class="form-field half">
            <label class="form-label">{{ labels.numeroDaConta }}</label>
            <input [(ngModel)]="form.numeroConta" type="text" pInputText
                   [placeholder]="placeholders.numeroDaConta" class="w-full" />
          </div>
          <div class="form-field full">
            <label class="form-label">{{ labels.tipoDeConta }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoConta"
                        [options]="tipoConta" optionLabel="label"
                        [placeholder]="placeholders.selecione" [(ngModel)]="form.tipoConta"
                        [filter]="false" [showClear]="false"
                        [readonly]="true" [ngClass]="{'p-disabled': true}"
                        styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Informacoes Adicionais -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon info-icon">
          <i class="pi pi-info-circle"></i>
        </div>
        <span class="card-header-title">{{ texts.informacoesAdicionais }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field full">
            <label class="form-label">{{ labels.descricao }} <span class="required">*</span></label>
            <input [class.error-field]="isFormSubmitted && !form.descricao"
                   [(ngModel)]="form.descricao" type="text" pInputText
                   [placeholder]="placeholders.descricao" class="w-full" />
          </div>
          <div class="form-field full">
            <label class="form-label">{{ 'nova-conta.labels.aceita_tarjeta_qrcode' | translate }}</label>
            <div class="flex align-items-center gap-2">
              <p-inputSwitch [(ngModel)]="form.aceitaTarjetaQrcode"></p-inputSwitch>
              <small class="text-500">{{ 'nova-conta.texts.aceita_tarjeta_qrcode_ajuda' | translate }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna Direita -->
  <div class="column-right">
    <!-- Card Valores -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon values-icon">
          <i class="pi pi-dollar"></i>
        </div>
        <span class="card-header-title">{{ texts.valores }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ labels.moeda }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.moeda"
                        [options]="moedas" optionLabel="label"
                        [placeholder]="placeholders.selecione" [(ngModel)]="form.moeda"
                        [filter]="true" filterBy="label" [showClear]="true"
                        styleClass="w-full" appendTo="body">
              <ng-template pTemplate="selectedItem" let-moeda>
                <div class="dropdown-moeda-item" *ngIf="moeda">
                  <img [src]="moeda.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ moeda.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-moeda>
                <div class="dropdown-moeda-item">
                  <img [src]="moeda.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ moeda.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ labels.saldo }} <span class="required">*</span></label>
            <p-inputNumber [class.error-field]="isFormSubmitted && form.saldo === null"
                   [(ngModel)]="form.saldo"
                   [locale]="selectedLocale"
                   [minFractionDigits]="selectedCasasDecimais"
                   [maxFractionDigits]="selectedCasasDecimais"
                   [useGrouping]="true"
                   [placeholder]="placeholders.saldo"
                   styleClass="w-full">
            </p-inputNumber>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Botoes de Acao -->
<div class="actions-container">
  <button pButton [label]="botoes.voltar" (click)="navigateBack()"
    severity="secondary" icon="pi pi-arrow-left" class="btn-secondary"></button>
  <button pButton [label]="botoes.salvar" icon="pi pi-check"
    (click)="submit()" class="btn-primary"></button>
</div>

<p-toast />
